import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { IecPlaceVoteComponent } from '../../../iec-place-vote/iec-place-vote.component';
import { DateFormatPipe } from '../../../../../controls/pipes/date-format.pipe';
import { IIecBallotVote } from '../../../../shared/models/iec/iec-ballot-vote';

@Component({
    selector: 'app-iec-history-column',
    templateUrl: './iec-history-column.component.html',
    styleUrl: './iec-history-column.component.scss',
    standalone: false
})
export class IecHistoryColumnComponent {
  @Input() vote: IIecBallotVote | null = null;
  @Input() isProxyVoteEnable: boolean = false;
  @Input() afterSaveSubject: Subject<string> = new Subject<string>();

  isEligible: boolean = false;
  lastUpdated: string = '';

    constructor(
      private _modalService: NgbModal,
      private dateFormatPipe: DateFormatPipe
    ) {}

  ngOnInit(): void {
    if (this.vote && this.vote.lastUpdated) {
      this.isEligible = this.vote.isEligible;
      this.lastUpdated = this.dateFormatPipe.transform(this.vote.lastUpdated);
    }
  }


  openProxyVoteModal() {
      const modalRef = this._modalService.open(IecPlaceVoteComponent, { windowClass: 'place-vote-custom-modal', centered: true});
      modalRef.componentInstance.votes = [this.vote];
      modalRef.componentInstance.isProxyVote = true;
      modalRef.result.then(r => {
        if(r) {
          this.afterSaveSubject.next(r);
        }
      })
  }
}
